import React, { useEffect, useState } from 'react';
import { Popover } from 'react-tiny-popover';
import { useSelector } from 'react-redux';
// import ChevronDownIcon from 'calcite-ui-icons-react/ChevronDownIcon';
import moment from 'moment';

import MapController from '../../../../controllers/MapController';

import { RootState } from '../../../../reducers/app';

import './my-layer.scss';
import { DateItem } from '../../../../types/react-select-options';
import PlanetImageSelector from './planet-image-selector';

const PlanetLayer = () => {
  // LOCAL STATE
  const [yearSelect, setYearSelect] = useState<DateItem | ''>();
  const [monthSelect, setMonthSelect] = useState<DateItem | ''>();
  const [yearList, setYearList] = useState<Array<String>>([]);
  const [monthList, setMonthList] = useState<Array<String>>([]);
  const [mosaicsList, setMosaicsList] = useState<Array<any>>([]);
  const [selectedPopover, setSelectedPopover] = useState<boolean>(false);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

  // REDUX
  const visibleLayers = useSelector((state: RootState) => state.mapview.visibleLayers);

  const getAllYears = (currentList: Array<any>) => {
    return currentList.reduce((acc, item) => {
      let _acc = acc;
      const date = item.imagery_date;
      const year = date.getFullYear();
      if (acc.indexOf(year) === -1) {
        _acc = [..._acc, year];
      }
      return _acc;
    }, []);
  };

  // updates months from list of
  const getMonths = (currentList: Array<any>, selectedYear: number | undefined) => {
    return currentList.reduce((acc, item) => {
      let _acc = acc;
      const date = new Date(item.imagery_date);
      const year = date.getFullYear();
      const month = date.getMonth();
      if (acc.indexOf(month) === -1 && year === selectedYear) {
        _acc = [..._acc, month];
      }
      return _acc;
    }, []);
  };

  // update list of
  const updateMosaicList = async () => {
    const list = await MapController.getMosaicsList();
    setMosaicsList([...list]);

    const year = { value: list[list.length - 1].imagery_date.getFullYear(), label: list[list.length - 1].imagery_date.getFullYear() }
    const month = { value: list[list.length - 1].imagery_date.getMonth(), label: months[list[list.length - 1].imagery_date.getMonth()] }
    setYearSelect(year)
    setMonthSelect(month)
    const _years = getAllYears(list);
    setYearList([
      ..._years.map((item: number) => {
        return { label: item.toString(), value: item };
      }),
    ]);
  };

  useEffect(() => {
    updateMosaicList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (yearSelect === '') return;
    let _months = getMonths(mosaicsList, yearSelect?.value);

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

    setMonthList([
      ..._months.map((item: number) => {
        return { label: months[item], value: item + 2 };
      }),
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [yearSelect, mosaicsList]);

  const clickOutside = (e: any) => {
    if (e.target.classList.contains('left-panel-select__option')) return;
    setSelectedPopover(false)
  }

  const updatePlanetLayer = () => {
    const planetLayerVisible = visibleLayers.includes('planet-images');
    if (!monthSelect || !yearSelect || !mosaicsList[0]) return;

    const dateMatch = moment(new Date().toUTCString())
      .set({
        month: monthSelect.value - 2,
        year: yearSelect.value,
        date: 1,
        hour: 0,
        minute: 0,
        second: 0,
        milliseconds: 0,
      })
      .toDate();

    const mosaic = mosaicsList.find((mos) => {
      const imageryYear = moment(new Date(mos.imagery_date)).format('YYYY-MM');
      const date = moment(new Date(dateMatch)).format('YYYY-MM');

      return imageryYear === date;
    });

    if (mosaic) {
      MapController.addPlanetLayer(mosaic.url_tiles, planetLayerVisible);
    }
  };

  return (
    <div className='layer-container border-bottom'>
      <div className='layer'>
        <div className='layer-title__wrapper'>
          <input
            type='checkbox'
            onChange={() =>
              MapController.updateLayerVisibility('planet-images', !visibleLayers.includes('planet-images'))
            }
          />
          <div className='layer-title'>Planet Imagery</div>
        </div>
        <div className='tools'>
          <Popover
            isOpen={selectedPopover}
            positions={['right']}
            onClickOutside={clickOutside}
            content={
              <PlanetImageSelector
                setSelectedPopover={setSelectedPopover}
                monthList={monthList}
                monthSelect={monthSelect}
                setMonthSelect={setMonthSelect}
                yearList={yearList}
                yearSelect={yearSelect}
                setYearSelect={setYearSelect}
                updatePlanetLayer={updatePlanetLayer}
              />
            }
          >
            <span onClick={() => setSelectedPopover(!selectedPopover)} className='esri-icon-time-clock'></span>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default PlanetLayer;
